import { APP_NAME } from 'src/constants/app'

export const AUTH_STORAGE_KEY = `${APP_NAME}/auth`
